import * as React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

/** The tint behind something picked, the same one MUI uses for a selected list item. */
export const SELECTED_TINT = "rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-selectedOpacity))";

interface SectionCardProps {
	/** Anchor the form scrolls to when this section has something to fix. */
	id: string;
	step: number;
	title: string;
	description?: React.ReactNode;
	children: React.ReactNode;
}

/** One numbered part of the request form. */
export function SectionCard({ id, step, title, description, children }: SectionCardProps): React.JSX.Element {
	return (
		<Card id={id} sx={{ scrollMarginTop: 96 }}>
			<CardContent sx={{ p: { xs: 2.5, sm: 3.5 }, "&:last-child": { pb: { xs: 2.5, sm: 3.5 } } }}>
				<Stack spacing={2.5}>
					<Stack direction="row" spacing={1.75} sx={{ alignItems: "flex-start" }}>
						<Box
							aria-hidden
							sx={{
								flex: "none",
								width: 30,
								height: 30,
								borderRadius: "50%",
								bgcolor: SELECTED_TINT,
								color: "primary.main",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: 14,
								fontWeight: 600,
							}}
						>
							{step}
						</Box>
						<Box>
							<Typography variant="h6">{title}</Typography>
							{description ? (
								<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
									{description}
								</Typography>
							) : null}
						</Box>
					</Stack>
					{children}
				</Stack>
			</CardContent>
		</Card>
	);
}
